import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';

const PropertyList = React.lazy(() => import('components/Property/List/List'));

function ScreensPropertyList() {
  return (
    <BaseLayout>
      <DocumentTitle>Property Management</DocumentTitle>
      <Suspense fallback={<UILoader />}>
        <PropertyList />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensPropertyList;
